import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import uk from 'vuetify/src/locale/uk.ts'

Vue.use(Vuetify)

const opts = {
  lang: {
    locales: {
      uk
    },
    current: 'uk'
  },
  /* theme: {
    themes: {
      light: {
        dark: '#1e1e2f'
      },
    },
  }, */
}

export default new Vuetify(opts)